export default __webpack_public_path__ + "static/media/zoom-in-fixed.017f7c21.png";